import { landingExploreCards } from './landingExploreContent'
import { landingMotionVideos } from './landingMotionContent'

// Both signup previews share the same artwork. Companion details describe the
// sample characters; these cards do not open or modify live Discover profiles.
const companions = {
  'landing-marina-blonde': {
    name: 'Ella',
    age: 24,
    scenarioKey: 'landingV2_scenarioMarina',
  },
  'landing-moonlit-elf': {
    name: 'Seraphina',
    age: 25,
    scenarioKey: 'landingV2_scenarioElf',
  },
  'landing-sunset-sport-anime': {
    name: 'Rin',
    age: 24,
    scenarioKey: 'landingV2_scenarioSport',
  },
  'landing-vinyl-store-blonde': {
    name: 'Skye',
    age: 25,
    scenarioKey: 'landingV2_scenarioVinyl',
  },
  'landing-garden-brunette': {
    name: 'Isla',
    age: 24,
    scenarioKey: 'landingV2_scenarioGarden',
  },
  'landing-festival-emo-anime': {
    name: 'Raven',
    age: 24,
    scenarioKey: 'landingV2_scenarioFestival',
  },
  'landing-coastal-runner-v2': {
    name: 'Zoe',
    age: 25,
    scenarioKey: 'landingV2_scenarioCoastal',
  },
  'landing-midnight-rooftop-v2': {
    name: 'Amara',
    age: 24,
    scenarioKey: 'landingV2_scenarioRooftop',
  },
  'landing-vinyl-studio-v2': {
    name: 'Maya',
    age: 24,
    scenarioKey: 'landingV2_scenarioStudio',
  },
  'landing-moonlit-arcade-anime-v2': {
    name: 'Akira',
    age: 25,
    scenarioKey: 'landingV2_scenarioArcade',
  },
  'landing-glasshouse-glasses-v2': {
    name: 'Chloe',
    age: 24,
    scenarioKey: 'landingV2_scenarioGlasshouse',
  },
  'landing-rainbow-canal-illustration-v2': {
    name: 'Luna',
    age: 24,
    scenarioKey: 'landingV2_scenarioCanal',
  },
  'landing-boardwalk-blonde-v2': {
    name: 'Summer',
    age: 24,
    scenarioKey: 'landingV2_scenarioBoardwalk',
  },
  'landing-emerald-cove-v2': {
    name: 'Sienna',
    age: 24,
    scenarioKey: 'landingV2_scenarioCove',
  },
  'landing-blue-top-night-market-v2': {
    name: 'Amber',
    age: 24,
    scenarioKey: 'landingV2_scenarioMarket',
  },
}

export const landingBrowseContent = {
  create: {
    title: 'landingV2_browseCreateTitle',
    description: 'landingV2_browseCreateBody',
    href: '/explore',
    action: 'landingV2_browseCreateAction',
  },
  chat: {
    title: 'landingV2_browseChatTitle',
    description: 'landingV2_browseChatBody',
    href: '/signup',
    action: 'landingV2_startChatting',
    cards: landingExploreCards
      .filter(({ nsfw, blurred }) => !nsfw && !blurred)
      .map((card) => ({
        id: `companion-${card.id}`,
        src: card.imageUrl,
        video: landingMotionVideos[card.id],
        alt: card.title,
        translationId: card.id,
        ...companions[card.id],
      })),
  },
}
